var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_259_49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8182 11.5199L11 18.2726L4.18179 11.5199C3.73206 11.0823 3.37783 10.5563 3.14138 9.97502C2.90493 9.39376 2.79139 8.76985 2.80791 8.14256C2.82444 7.51527 2.97066 6.8982 3.23738 6.3302C3.50411 5.7622 3.88555 5.25558 4.35768 4.84224C4.82982 4.4289 5.38243 4.11779 5.98071 3.92851C6.57898 3.73923 7.20997 3.67588 7.83394 3.74244C8.45791 3.809 9.06133 4.00404 9.60622 4.31526C10.1511 4.62649 10.6256 5.04717 11 5.5508C11.3759 5.05082 11.851 4.63382 12.3955 4.3259C12.94 4.01798 13.5422 3.82576 14.1645 3.76128C14.7867 3.69679 15.4155 3.76144 16.0116 3.95116C16.6077 4.14088 17.1582 4.4516 17.6287 4.86386C18.0991 5.27613 18.4794 5.78106 18.7458 6.34707C19.0122 6.91308 19.1588 7.52797 19.1766 8.15327C19.1944 8.77856 19.0829 9.4008 18.8492 9.98103C18.6154 10.5613 18.2644 11.087 17.8182 11.5253",
    stroke: "#0037A6",
    strokeWidth: 1.81818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_259_49"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8182,
    height: 21.8182,
    fill: "white",
    transform: "translate(0.0908813 0.0908203)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon_heart.459d77e12a05bcacf4dc70d609b9feaf.svg";
export { ForwardRef as ReactComponent };